import CurrentCountry from '@phoenix/components/CurrentCountry';

const currentCountry = new CurrentCountry();
currentCountry.update();

Object.assign(window, {
  currentCountry,
});
